import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { Btn } from '../../../AbstractElements';
import { useTranslation } from 'react-i18next';

interface DeleteConfirmModalProps {
  isOpen: boolean;
  toggle: () => void;
  onConfirm: () => void;
  title?: string;
  message?: string;
}

const DeleteConfirmModal: React.FC<DeleteConfirmModalProps> = ({
  isOpen,
  toggle,
  onConfirm,
  title,
  message,
}) => {
  const { t } = useTranslation();
  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>{title || t('Confirmar Eliminación')}</ModalHeader>
      <ModalBody>
        <p>{message || t('¿Estás seguro de que deseas eliminar este elemento?')}</p>
        <p className="text-danger">
          <small>{t('Esta acción no se puede deshacer.')}</small>
        </p>
      </ModalBody>
      <ModalFooter>
        <Btn color="secondary" onClick={toggle}>
          {t('Cancelar')}
        </Btn>
        <Btn color="primary" onClick={onConfirm}>
          {t('Aceptar')}
        </Btn>
      </ModalFooter>
    </Modal>
  );
};

export default DeleteConfirmModal;

